import { post_api } from "api";
import { useAuth } from "context/AuthContext";
import { isReady, requestToken } from "firebaseConfig";
import { useFormik } from "formik";
import { useState } from "react";
import { toast } from "react-toastify";
import { emailRegex, passwordRegex } from "variables/regex";
import RoutesName from "variables/route";
import * as yup from "yup";

const useSignUpHook = () => {
    const { signin } = RoutesName;
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const initialValues = {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        terms_and_conditions: false,
        recaptcha: "",
    };

    const validationSchema = yup.object().shape({
        first_name: yup
            .string()
            // .min(2, "Too Short!")
            // .max(50, "Too Long!")
            .required("Required"),
        last_name: yup.string(),
        // .min(2, "Too Short!")
        // .max(50, "Too Long!")
        // .required("Required"),
        email: yup
            .string()
            .required("Required")
            .matches(emailRegex, "Invalid email"),
        password: yup
            .string()
            .required("Required")
            .matches(
                passwordRegex,
                "Password must contain at least one letter, one number and be at least 8 characters long."
            ),
        terms_and_conditions: yup.boolean().required("Required"),
        recaptcha: yup.string().required("reCAPTCHA is required"),
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true)
                await isReady;
                const token = await requestToken();
                values.deviceToken = token;
                const { message, data } = await post_api("auth/register", values);
                if (data) {
                    login(data);
                }
                toast.success(message);
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.error("Error:", error);
                toast.error(error.message);
            }
        },
    });

    const { values, errors, touched, handleChange, handleSubmit, handleBlur, setFieldValue } =
        formik;

    const handleLinkClick = (event) => {
        event.preventDefault();
        window.open("/terms-and-conditions", "_blank", "noopener,noreferrer");
    };
    return {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        handleBlur,
        signin,
        handleLinkClick,
        loading,
        setFieldValue,
    };
};

export default useSignUpHook;
